import { css } from '@emotion/core';

export const responsiveContainerCSS = css`
    display: flex;
    justify-content: space-between;
    margin-left: 0.75rem;
    margin-right: 0.75rem;
`;
